(() => {
  const CSS = `
    .group-container.group-container--selected .group-label {
      box-shadow: 0 4px 4px 0 #00000040;
    }
  `.trim();

  function injectStyleIntoShadow(shadowRoot) {
    if (!shadowRoot) return false;
    if (shadowRoot.querySelector('style[data-skio-style="injected"]')) return true;

    const style = document.createElement('style');
    style.setAttribute('data-skio-style', 'injected');
    style.textContent = CSS;
    shadowRoot.appendChild(style);
    return true;
  }

  function tryInject(el, attempts = 40) {
    if (!el) return;
    if (el.shadowRoot && injectStyleIntoShadow(el.shadowRoot)) return;

    let count = 0;
    const id = setInterval(() => {
      if (el.shadowRoot && injectStyleIntoShadow(el.shadowRoot)) {
        clearInterval(id);
        return;
      }
      if (++count >= attempts) clearInterval(id);
    }, 125);
  }

  function scanAll() {
    document.querySelectorAll('skio-plan-picker').forEach(tryInject);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scanAll, { once: true });
  } else {
    scanAll();
  }

  const mo = new MutationObserver(mutations => {
    for (const m of mutations) {
      for (const node of m.addedNodes) {
        if (!(node instanceof Element)) continue;
        if (node.matches?.('skio-plan-picker')) {
          tryInject(node);
        } else {
          node.querySelectorAll?.('skio-plan-picker').forEach(tryInject);
        }
      }
    }
  });

  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
